<template>
  <div
    id="admin-users-page"
  >
    <TeamMembers />
  </div>
</template>

<script>
import TeamMembers from '@/components/team/tabs/TeamMembers';

export default {
    name: 'AdminUsersPage',
    components: {
        TeamMembers,
    },
};
</script>
